import { initContract } from "@ts-rest/core";
import { LoyaltyApi } from "../../interfaces/loyalty/api";

const contractInstance = initContract();

export const loyaltyContract = contractInstance.router({
  getLoyalty: {
    method: "GET",
    path: "/loyalty",
    responses: {
      200: LoyaltyApi.Program.schema.nullable(),
    },
  },
});
